var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkynityIsland(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33.138,
    height: 31.37007874015748,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 1,
    x2: 0.25,
    y1: 0,
    y2: 1.25
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C6D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 1,
    x2: 0.81,
    y1: 0,
    y2: 1.81
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C6D8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "layer"
  }, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m0,5.95l0,0l0,6.13c0,0.97 0.79,1.76 1.76,1.76c0.98,0 1.77,0.79 1.77,1.76l0,4.97a1.83,1.83 0 0 0 3.66,0l0,-1.51a1.8,1.8 0 0 1 3.6,0l0,1.93c0,0.99 0.81,1.8 1.81,1.8l0.15,0c0.91,0 1.65,0.74 1.65,1.65c0,0.91 0.73,1.65 1.65,1.65l0.14,0c0.99,0 1.79,0.8 1.79,1.79l0,1.53a1.83,1.83 0 0 0 3.67,0l0,-5.65a1.81,1.81 0 0 1 3.61,0l0,0.26a1.83,1.83 0 0 0 3.66,0l0,-4.57c0,-1.01 0.82,-1.83 1.83,-1.83a1.83,1.83 0 0 0 1.83,-1.83l0,-9.76c-0.02,0.66 -0.76,1.32 -2.22,1.72l-11.42,3.16c-1.61,0.45 -3.69,0.45 -5.3,0l-11.42,-3.16c-1.48,-0.41 -2.22,-1.08 -2.22,-1.74c0,-0.02 0,-0.04 0,-0.06zm32.58,0.03l0,0l0,0zm-21.85,20.77a1.83,1.83 0 0 1 -3.66,0l0,-1.39c0,-1.01 0.82,-1.83 1.83,-1.83c1.01,0 1.83,0.82 1.83,1.83l0,1.39z",
    fill: "url(#a)",
    fillRule: "evenodd",
    id: "svg_1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.22,4.26c-2.96,0.82 -2.96,2.67 0,3.49l11.42,3.16c1.61,0.45 3.69,0.45 5.3,0l11.42,-3.16c2.96,-0.82 2.96,-2.67 0,-3.49l-11.42,-3.16c-1.61,-0.45 -3.69,-0.45 -5.3,0l-11.42,3.16z",
    fill: "url(#b)",
    id: "svg_2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkynityIsland);
export default __webpack_public_path__ + "static/media/skynity-island.eb763339822671f9edef7aa4b65952f9.svg";
export { ForwardRef as ReactComponent };